import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

import Navbar from '@/components/navbar';
import Footer from '@/components/Footer/Footer';
import AppWrapper from '@/components/AppWrapper';

import { routes } from './config/routes';
import { getEnvChain, wagmiConfig } from './config/chainConfig';

import './styles.css';
import '@rainbow-me/rainbowkit/styles.css';

const queryClient = new QueryClient();

export default function App() {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          initialChain={getEnvChain()}
          theme={darkTheme({ accentColor: '#7c3aed' })}
          modalSize="compact"
          appInfo={{ appName: 'Token Racer' }}
        >
          <AppWrapper>
            <Router>
              <div className="app-container">
                <Navbar />
                <Routes>
                  {routes.map(route => (
                    <Route key={route.path} path={route.path} element={route.element} />
                  ))}
                </Routes>
                <Footer />
              </div>
            </Router>
          </AppWrapper>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
